'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _loveButton = require('./loveButton.js');

var _loveButton2 = _interopRequireDefault(_loveButton);

var _fullscreenSocialDownload = require('./fullscreenSocialDownload.js');

var _fullscreenSocialDownload2 = _interopRequireDefault(_fullscreenSocialDownload);

var _fullscreenShareButtons = require('./fullscreenShareButtons.js');

var _fullscreenShareButtons2 = _interopRequireDefault(_fullscreenShareButtons);

var _fullscreenCartIcon = require('./fullscreenCartIcon.js');

var _fullscreenCartIcon2 = _interopRequireDefault(_fullscreenCartIcon);

var _utils = require('../utils');

var _fullscreen = require('@wix/photography-client-lib/dist/src/versioning/features/fullscreen');

var _translationUtils = require('@wix/photography-client-lib/dist/src/utils/translationUtils');

var _translationUtils2 = _interopRequireDefault(_translationUtils);

var _info = require('-!svg-react-loader!../assets/images/fullscreen-store/info.svg');

var _info2 = _interopRequireDefault(_info);

var _info_invert = require('-!svg-react-loader!../assets/images/fullscreen-store/info_invert.svg');

var _info_invert2 = _interopRequireDefault(_info_invert);

var _FullscreenExpandCloseButton = require('./FullscreenExpandCloseButton');

var _FullscreenExpandCloseButton2 = _interopRequireDefault(_FullscreenExpandCloseButton);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenDesktopNavbar = function (_React$Component) {
  (0, _inherits3.default)(FullscreenDesktopNavbar, _React$Component);

  function FullscreenDesktopNavbar(props) {
    (0, _classCallCheck3.default)(this, FullscreenDesktopNavbar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenDesktopNavbar.__proto__ || (0, _getPrototypeOf2.default)(FullscreenDesktopNavbar)).call(this, props));

    _this.handleShareArrowNavigation = _this.handleShareArrowNavigation.bind(_this);
    _this.state = {
      shareBoxIsOpened: false,
      focusedShareIcon: 0
    };

    _this.isStoreGallery = _utils.utils.isStoreGallery();
    return _this;
  }

  (0, _createClass3.default)(FullscreenDesktopNavbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar()) {
        this.rightButtonElement && this.rightButtonElement.focus();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      if (this.isStoreGallery) {
        var providerId = _utils.utils.getProviderFromGalleryInfo(newProps.galleryInfo);
        new _promise2.default(function (resolve) {
          require.ensure([], function (require) {
            resolve(require('@wix/pro-gallery-artstore-statics'));
          });
        }).then(function (cart) {
          cart.cartApi.getCartItems(providerId).then(function (arrItems) {
            var count = cart.cartApi.getCartItemsCount(arrItems);
            _this2.setState({ cartItemsCount: count });
          });
        });
      }
    }
  }, {
    key: 'handleShareArrowNavigation',
    value: function handleShareArrowNavigation(e, type) {
      if (!this.state.shareBoxIsOpened) {
        //the keypress events are only effective when the share box was opened via Click or Focus+Enter
        return true;
      }

      switch (e.keyCode || e.charCode) {
        case 38: //up
        case 37: //left
        case 33:
          //page up
          e.preventDefault();
          e.stopPropagation();
          this.setState({
            focusedShareIcon: Math.max(1, this.state.focusedShareIcon - 1)
          });
          return false;
        case 39: //right
        case 40: //down
        case 34:
          //page down
          e.preventDefault();
          e.stopPropagation();
          this.setState({
            focusedShareIcon: Math.min(type === 'text' ? 4 : 5, this.state.focusedShareIcon + 1)
          });
          return false;
        case 9: //tab
        case 27:
          //esc
          e.preventDefault();
          e.stopPropagation();
          this.shareBoxButton.focus();
          this.setState({
            focusedShareIcon: 0,
            shareBoxIsOpened: false
          });
          return false;
      }

      return true;
    }
  }, {
    key: 'getLoveButton',
    value: function getLoveButton() {
      var props = _lodash2.default.pick(this.props.current.item, ['id', 'item', 'idx', 'itemId', 'hashtag']);
      var loveButton = _react2.default.createElement(_loveButton2.default, (0, _extends3.default)({}, props, {
        key: 'fullscreen-love-' + this.props.id,
        layout: 'fullscreen',
        device: 'desktop',
        styleParams: this.props.styleParams,
        isPreview: this.props.isPreview // to preserve LoveButton API
        , showCounter: true
      }));
      return this.props.isPreview ? _react2.default.createElement(
        'div',
        { title: _translationUtils2.default.getByKey('This option is not available in editor') },
        loveButton
      ) : _react2.default.createElement(
        _react2.default.Fragment,
        null,
        loveButton
      );
    }
  }, {
    key: 'getDownload',
    value: function getDownload() {
      return _react2.default.createElement(_fullscreenSocialDownload2.default, {
        key: 'fullscreen-download-' + this.props.id,
        layout: 'fullscreen',
        device: 'desktop',
        current: this.props.current,
        styleParams: this.props.styleParams
      });
    }
  }, {
    key: 'getShareComponent',
    value: function getShareComponent(showDownload, shareIcon) {
      var _this3 = this;

      var storeClass = this.isStoreGallery ? 'pro-fullscreen-store' : '';
      var shareBoxOpenedClass = this.state.shareBoxIsOpened ? 'pro-fullscreen-hovered' : '';
      var type = this.props.current.item.type;

      return _react2.default.createElement(
        'div',
        {
          key: 'shareComponent',
          className: 'fullscreen-icon fullscreen-social-share-box ' + storeClass + ' ' + shareBoxOpenedClass,
          onKeyDown: function onKeyDown(e) {
            return _this3.handleShareArrowNavigation(e, type);
          }
        },
        shareIcon,
        _react2.default.createElement(_fullscreenShareButtons2.default, {
          item: this.props.current.item,
          focus: this.state.focusedShareIcon
        })
      );
    }
  }, {
    key: 'getFakeShareComponent',
    value: function getFakeShareComponent(showDownload, shareIcon) {
      var storeClass = this.isStoreGallery ? 'pro-fullscreen-store' : '';

      return _react2.default.createElement(
        'div',
        {
          className: 'show-tooltip fullscreen-icon fullscreen-social-share-box ' + storeClass,
          title: _translationUtils2.default.getByKey('Gallery_Sharing_Disabled_In_Editor')
        },
        shareIcon
      );
    }
  }, {
    key: 'getShareIcon',
    value: function getShareIcon() {
      var _this4 = this;

      return _react2.default.createElement('button', {
        className: 'fullscreen-social-share-icon progallery-svg-font-icons-share-store has-custom-focus',
        tabIndex: 0,
        ref: function ref(button) {
          return _this4.shareBoxButton = button;
        },
        onClick: function onClick() {
          _this4.setState({ shareBoxIsOpened: !_this4.state.shareBoxIsOpened });
        },
        'aria-label': 'Share'
      });
    }
  }, {
    key: 'getShareButtons',
    value: function getShareButtons() {
      var showDownload = this.props.styleParams.allowDownload && !this.props.current.item.isDemo;
      var shareIcon = this.getShareIcon();

      if (!this.props.styleParams.allowSocial) {
        return false;
      }

      return !this.props.isPreview ? this.getShareComponent(showDownload, shareIcon) : this.getFakeShareComponent(showDownload, shareIcon);
    }
  }, {
    key: 'getCartButton',
    value: function getCartButton() {
      return _react2.default.createElement(_fullscreenCartIcon2.default, { cartItemsCount: this.state.cartItemsCount });
    }
  }, {
    key: 'getSocialBarContainer',
    value: function getSocialBarContainer() {
      var styleParams = this.props.styleParams;

      var loveButton = styleParams.loveButton ? this.getLoveButton() : '';
      var downloadButton = this.getDownload();
      var shareButtons = this.getShareButtons();

      return _react2.default.createElement(
        'div',
        { className: 'fullscreen-social' },
        [_fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() && !_utils.utils.isMobile() ? this.getExpandButtonIfNeeded() : false, _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() && this.isStoreGallery ? this.getCartButton() : false, _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? this.getMoreInfoButton() : false, _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? downloadButton : loveButton, _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? loveButton : downloadButton, shareButtons]
      );
    }
  }, {
    key: 'getCloseButton',
    value: function getCloseButton() {
      var _this5 = this;

      var closeExpandIconClass = 'progallery-svg-font-icons-close-x has-custom-focus';
      if (this.props.window.expanded && _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar()) {
        closeExpandIconClass = 'progallery-svg-font-icons-shrink-arrow pro-fullscreen-shrink-button has-custom-focus';
      }

      return _react2.default.createElement(_FullscreenExpandCloseButton2.default, {
        iconClass: closeExpandIconClass,
        onClick: function onClick() {
          return _this5.props.actions.closeExpandBrowser();
        },
        tabIndex: 0,
        ariaLabel: 'Exit ' + (this.props.window.expanded ? 'Full Screen' : 'Expand Mode'),
        shoudAutofocus: !!this.props.navigatedInto
      });
    }
  }, {
    key: 'getNavigationArrows',
    value: function getNavigationArrows() {
      var _this6 = this;

      return [_react2.default.createElement('button', {
        className: 'fullscreen-icon fullscreen-next progallery-svg-font-icons-arrow_right ' + (this.props.current.idx >= this.props.totalItems - 1 ? ' fullscreen-icon-disabled ' : ''),
        ref: function ref(_ref) {
          return _this6.rightButtonElement = _ref;
        },
        onClick: function onClick() {
          return _this6.props.actions.fadeToNextSlide(1);
        },
        tabIndex: this.props.current.idx >= this.props.totalItems - 1 ? -1 : _utils.utils.getTabIndex('fullscreenNext'),
        'aria-label': 'Next Item'
      }), _react2.default.createElement('button', {
        className: 'fullscreen-icon fullscreen-prev progallery-svg-font-icons-arrow_left ' + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : ''),
        onClick: function onClick() {
          return _this6.props.actions.fadeToNextSlide(-1);
        },
        tabIndex: this.props.current.idx <= 0 ? -1 : _utils.utils.getTabIndex('fullscreenPrev'),
        'aria-label': 'Previous Item'
      })];
    }
  }, {
    key: 'getMoreInfoButton',
    value: function getMoreInfoButton() {
      var _props = this.props,
          styleParams = _props.styleParams,
          current = _props.current,
          actions = _props.actions,
          showInfo = _props.showInfo;

      var shouldHideMoreInfoButton = !styleParams.showInfoExpandButton || this.props.window.expanded || _utils.utils.isMobile() || !current.hasInfo;
      if (shouldHideMoreInfoButton) {
        return false;
      }
      var svgInfoWhite = _react2.default.createElement(
        'div',
        null,
        (0, _info2.default)()
      );
      var svgInfoBlack = _react2.default.createElement(
        'div',
        null,
        (0, _info_invert2.default)()
      );

      var showMoreIconClass = _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? '' : 'progallery-svg-font-icons-plus';
      var showLessIconClass = _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? '' : 'progallery-svg-font-icons-minus';

      return _react2.default.createElement(
        'button',
        {
          className: 'fullscreen-icon fullscreen-info ' + (showInfo ? showLessIconClass : showMoreIconClass),
          onClick: function onClick() {
            return actions.toggleInfo();
          },
          tabIndex: _utils.utils.getTabIndex('fullscreenInfo'),
          'aria-label': showInfo ? 'Hide Details' : 'Show More Details'
        },
        _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? showInfo ? svgInfoBlack : svgInfoWhite : false
      );
    }
  }, {
    key: 'getExpandButtonIfNeeded',
    value: function getExpandButtonIfNeeded() {
      var _this7 = this;

      var _props2 = this.props,
          styleParams = _props2.styleParams,
          actions = _props2.actions;

      if (!styleParams.allowFullscreenExpand) {
        return false;
      }
      var expandIconClass = _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? 'progallery-svg-font-icons-expand-arrow' : 'progallery-svg-font-icons-fullscreen';

      return _react2.default.createElement('button', {
        key: 'fullscreen-expand-' + this.props.id,
        className: 'fullscreen-icon has-custom-focus fullscreen-expand ' + expandIconClass,
        onClick: function onClick() {
          return actions.expandBrowser();
        },
        tabIndex: 0,
        ref: function ref(_ref2) {
          return _this7.fullscreenExpandButton = _ref2;
        },
        'aria-label': this.props.window.expanded ? 'Close full screen' : 'Open in full screen'
      });
    }
  }, {
    key: 'getNavigationContainer',
    value: function getNavigationContainer() {
      var controls = [_fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? false : this.getNavigationArrows(), _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? false : this.getMoreInfoButton(), _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() || this.props.window.expanded || _utils.utils.isMobile() ? false : this.getExpandButtonIfNeeded()];

      return _react2.default.createElement(
        'div',
        { className: 'fullscreen-nav' },
        this.getCloseButton(),
        this.isStoreGallery ? false : controls
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (_utils.utils.isSmallScreen()) {
        return false;
      }

      var shouldHideSocialBar = this.props.window.expanded;

      var socialBarContainer = shouldHideSocialBar ? _fullscreen.fullscreenVersionManager.useFullscreenNewDesktopNavbar() ? false : _react2.default.createElement('div', null) : this.getSocialBarContainer();

      var navigationContainer = this.getNavigationContainer();

      return _react2.default.createElement(
        'div',
        { className: 'fullscreen-desktop-navbar-container' },
        socialBarContainer,
        navigationContainer
      );
    }
  }]);
  return FullscreenDesktopNavbar;
}(_react2.default.Component);

exports.default = FullscreenDesktopNavbar;